module.exports = __webpack_public_path__ + "static/media/ethan-hickey-resume.f4aeb0c7.pdf";